import script from "./ProductCardShablone.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCardShablone.vue?vue&type=script&setup=true&lang=js"

import "./ProductCardShablone.vue?vue&type=style&index=0&id=3372177c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3372177c"]])

export default __exports__